const PAGE_NAME = 'collections_lobby';

const SOURCE_INFO = {
    name: PAGE_NAME,
};

module.exports = {
    PAGE_NAME,
    SOURCE_INFO,
};
